<div class="flex flex-col items-center text-center">
  <h2 class="mb-4">Unsaved changes</h2>

  <span class="text-text-secondary mb-10 leading-relaxed"
    >Your changes haven't been saved. If you leave now, they'll be discarded.</span
  >

  <div class="flex gap-5 w-full">
    <ui-button label="Keep editing" size="lg" variant="tertiary" class="flex-1" (onClick)="keepEditing()" />
    <ui-button label="Discard changes" size="lg" variant="destructive" class="flex-1" (onClick)="discardChanges()" />
  </div>
</div>
